export default "__VITE_ASSET__GoTHChrU__"